import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AppContext} from "../app-context";

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewsComponent {
  appContext = AppContext;

  ngAfterViewInit() {
    let newsItems = document.querySelectorAll('.d-none .news-item').length;
  }
}
